import { FC, useMemo } from "react";
import { usePost } from "../../components-system/api/use-post.hook";
import { usePut } from "../../components-system/api/use-put.hook";
import { useDelete } from "../../components-system/api/use-delete.hook";
import { FormContext } from "./context";
import { useGet } from "../../components-system/api";
import { DataSource } from "../_types";

// Form provider component
export const FormProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const create = usePost();
  const save = usePut();
  const del = useDelete();

  const contextValue = useMemo(() => ({
    get: useGet,
    create,
    save,
    delete: del,
  }), [create, save, del]);

  return (
    <FormContext.Provider value={contextValue}>
      {children}
    </FormContext.Provider>
  );
};
export const t = 0;
